import { createFileRoute, redirect } from "@tanstack/react-router";

import { EnrollForm } from "~/components/registration/enroll-form";
import { AuthCard } from "~/components/shell/auth-layout";
import { auth, authReady } from "~/lib/auth";

export const Route = createFileRoute("/(public)/aanmelden/$enrollCode/gegevens")({
  beforeLoad: async ({ params }) => {
    await authReady();
    const email = auth.currentUser?.email;
    if (!email) throw redirect({ to: "/aanmelden/$enrollCode", params });
    return { email };
  },
  component: DetailsStep,
});

function DetailsStep() {
  const { enrollCode } = Route.useParams();
  const { email } = Route.useRouteContext();

  return (
    <AuthCard>
      <EnrollForm enrollCode={enrollCode} email={email} />
    </AuthCard>
  );
}
